import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Upload, FileText, Target } from 'lucide-react';

export const HERO_BG = 'https://static.prod-images.emergentagent.com/jobs/c849dba7-0dd0-4750-80bd-42c89faa40b3/images/6a18271b999fad536c36cdc913b734fbd11eaf7440fed13d2b483e3807367a06.png';

export const countries = [
  { name: 'Canada', program: 'Skilled Migration Routes', flag: '\u{1F1E8}\u{1F1E6}', img: 'https://images.pexels.com/photos/11456645/pexels-photo-11456645.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'Australia', program: 'Points-Based Residency', flag: '\u{1F1E6}\u{1F1FA}', img: 'https://images.pexels.com/photos/15571948/pexels-photo-15571948.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'Germany', program: 'Skilled Work Routes', flag: '\u{1F1E9}\u{1F1EA}', img: 'https://images.pexels.com/photos/18539960/pexels-photo-18539960.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'UK', program: 'Sponsored & Talent Routes', flag: '\u{1F1EC}\u{1F1E7}', img: 'https://images.pexels.com/photos/36662554/pexels-photo-36662554.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'Portugal', program: 'Residency & Remote Work', flag: '\u{1F1F5}\u{1F1F9}', img: 'https://images.pexels.com/photos/1559908/pexels-photo-1559908.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'New Zealand', program: 'Skilled Migration', flag: '\u{1F1F3}\u{1F1FF}', img: 'https://images.pexels.com/photos/696680/pexels-photo-696680.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'Italy', program: 'Remote Work & Startup', flag: '\u{1F1EE}\u{1F1F9}', img: 'https://images.pexels.com/photos/2064827/pexels-photo-2064827.jpeg?auto=compress&cs=tinysrgb&w=400' },
  { name: 'Estonia', program: 'Remote Work Residency', flag: '\u{1F1EA}\u{1F1EA}', img: 'https://images.pexels.com/photos/36177625/pexels-photo-36177625.jpeg?auto=compress&cs=tinysrgb&w=400' },
];

export const steps = [
  { num: '01', title: 'Upload your CV', desc: 'Drop your PDF or text resume. Our AI reads it instantly.', icon: <Upload size={20} strokeWidth={2} /> },
  { num: '02', title: 'Answer a few questions', desc: 'Quick details about your goals, language, and preferences.', icon: <FileText size={20} strokeWidth={2} /> },
  { num: '03', title: 'Get your migration map', desc: 'See every country where you qualify, with scores, gates, and next steps.', icon: <Target size={20} strokeWidth={2} /> },
];

export const GRAD_TEXT = {
  background: 'linear-gradient(135deg, #F67425 0%, #BB0518 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export const EYEBROW = {
  fontFamily: 'var(--font-body)',
  fontSize: '0.7rem',
  fontWeight: 700,
  letterSpacing: '0.25em',
  textTransform: 'uppercase',
  color: '#F67425',
};

export const FadeUp = ({ children, delay = 0, className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
